import React from 'react';

export function NotificationCenter() {
  // Firebase notifications were used previously. Backend doesn't expose a notifications feed yet,
  // so we render nothing to keep UI/build stable while auth is migrated.
  return null;
}
